export const HeaderTabelSystemMargin = [
  'Valid',
  'Minimum Cost',
  'Percentage (%)',
  'Action',
];
